export default {
    state: {
        permissions: {
            photo: []
        }
    },
    actions: {
        async GET_ALL_PHOTO_PERMISSIONS({commit}, payload) {
            const url = '/api/v4/people/person/all-photo-permissions'
            const request = new Request(url, {
                method: 'GET',
                credentials: 'same-origin'
            });
            const response = await fetch(request);
            const json = await response.json();
            commit('SET_PHOTO_PERMISSIONS', json.data);

        },
        async UPDATE_PHOTO_PERMISSION({commit}, payload) {
            const {personId, permissionValue, clientId} = payload;

            
            const url = '/api/v4/people/person/update-photo-permissions'
            const request = new Request(url, {
                method: 'POST',
                credentials: 'same-origin',
                body: JSON.stringify({personId, status:permissionValue, clientId})
            });

            const response = await fetch(request);
            const json = await response.json();            
        }
    },
    mutations: {
        SET_PHOTO_PERMISSIONS({permissions}, payload) {
            permissions.photo = payload;
        }
    },
    getters: {
        photoPermissions({permissions}) {
            return permissions.photo;
        }
    }
}